import React, { useEffect } from "react";
import useBaseRequest from "../../api/BaseRequest";
import { TableHeaders, TableRow } from "../../components/table";
import moment from "moment";
import { Icon } from "../../modules/icon";
import { useDocumentService } from "../../services/useDocumentService";
import { Link, useLocation } from "react-router-dom";
import { Badge } from "../../components/badge";
import ChatGateway from "../../api/gateways/ChatGateway";

export function useChatTableReport({ reportId }: { reportId: string }) {
  // states
  const { getDocFileUrl } = useDocumentService();
  const location = useLocation();

  const [reportTableData, setReportTableData] = React.useState<TableRow[]>([]);
  const [reportTableHeaders, setReportTableHeaders] = React.useState<TableHeaders[]>([]);
  const [reportTableMetaData, setReportTableMetaData] = React.useState<{ totalCount?: number, generatedAt?: string, reportType?: string }>({});
  const [reportName, setReportName] = React.useState<string>("");

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const skip = queryParams.get("skip") ? parseInt(queryParams.get("skip") || "0") : 0;
    const limit = queryParams.get("limit") ? parseInt(queryParams.get("limit") || "10") : 10;
    getReportTableData({ reportId, skip, limit });
  }, [location.search]);

  // requests
  const { data, execute: getReportTableData, loading } = useBaseRequest(
    (payload: { reportId: string, skip: number, limit: number }) => ChatGateway.api.getTableReport(payload.reportId, payload.skip, payload.limit),
    {
      onCompleted: (data) => {
        const documents = data.data.rows;
        const docTable: TableRow[] = documents.map((doc: any) => {
          const row: TableRow = [];
          data.data.headers.forEach((header: { key: string, name: string }) => {
            row.push(doc[header.key]);
          });
          return row;
        });
        setReportTableData(docTable);
        setReportTableHeaders(data.data.headers);
        setReportTableMetaData(data.data.metadata);
        setReportName(data.filename);
      },
    }
  );

  return {
    reportTableData,
    reportTableHeaders,
    loading,
    getReportTableData,
    reportTableMetaData,
    reportName,
  };
}
